<template>
  <el-breadcrumb class="app-levelbar" separator="/">
    <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path">
      <span v-if='index==levelList.length-1'>{{item.name}}</span>
      <router-link v-else :to=" item.redirect||item.path">{{item.name}}</router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name);
      const last = matched[matched.length - 1];
      matched.length > 1 && last.name =='机柜详情' ? matched.splice(1, 0,{ name: '机柜管理', path: '/cabinets' }) : null ;
      this.levelList = matched;
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-levelbar.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Levelbar.vue?21113cc9